'use strict';
import delegate from 'delegate';
import angular from 'angular';

let controller = function () {
};

let directive = function (als, modalService) {
    return {
        restrict: 'A',
        controller,
        controllerAs: '$ctrl',
        link: function (scope, element, attr, ctrl) {
            delegate(element, '[cars-tracking-als-clickthru]', 'click', function (event) {
                event.stopPropagation();

                const alsParams = JSON.parse(event.delegateTarget.getAttribute("cars-tracking-als-clickthru"));

                if (alsParams.leadTypeId) {
                    als.lead(alsParams);
                } else {
                    als.clickthru(alsParams);
                }
            });


            delegate(element, '[cars-tracking-dtm-clickthru]', 'click', function (event) {
                event.stopPropagation();

                const dtmParams = JSON.parse(event.delegateTarget.getAttribute("cars-tracking-dtm-clickthru"));

                dtmParams.forEach((item)=>{
                    changeState(item);
                });
            });


            delegate(element, '[cui-modal-toggle]', 'click', function (event) {
                event.stopPropagation();

                const modalName = event.delegateTarget.getAttribute("cui-modal-toggle");

                const modal = modalService.get(modalName);

                if (modal) {
                    modal.toggle();
                } else {
                    console.log(`cui.overlays.modal - modalToggleDirective: no modal found for id=${modalName}`);
                }
            });

            delegate(element, '[photo-lightbox-launch]', 'click', function(event){
                modalService.get('photoLightbox').toggle();
            });

        }
    };
};

directive.$inject = ['alsService', 'modalService'];


export default angular.module('cars.vdp.wrapper', [])
    .directive('vdpWrapper', directive)
    .name;






function changeState(params) {
    const hasPageState = !!(window.CARS && window.CARS.PageState && window.CARS.digitalData);

    if (hasPageState) {
        if (params.method === 'push') {
            window.CARS.PageState.push(params.key, params.value, params.emit);
        }

        //if (params.method === 'set') {
        //    window.CARS.PageState.push(.set(params.key, params.value, params.emit);
        //}
        //
        //if (params.method === 'assign') {
        //    window.CARS.PageState.push(.assign(params.object, params.emit);
        //}
        //
        //if (params.method === 'get') {
        //    window.CARS.PageState.push(.get(params.key);
        //}
        //
        //if (params.method === 'remove') {
        //    window.CARS.PageState.push(.remove(params.key, params.emit);
        //}
        //
        //if (params.method === 'last') {
        //    window.CARS.PageState.push(.last(params.key);
        //}
        //
        //if (params.method === 'pop') {
        //    window.CARS.PageState.push(.pop(params.key, params.emit);
        //}
    }
}